import {Component, OnInit, ViewChild} from '@angular/core';
import {ServiceRemark} from '../../../dealer-system/Models/ServiceRemark';
import {Helper} from '../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../../../dealer-system/Services/order.service';
import {Order} from '../../../back-office/Models/Order';
import {AuthenticationService} from '../../Services/authentication.service';

@Component({
  selector: 'app-manage-service-remark',
  templateUrl: './manage-service-remark.component.html',
  styleUrls: ['./manage-service-remark.component.scss']
})

export class ManageServiceRemarkComponent implements OnInit {

  public serviceRemark: ServiceRemark = new ServiceRemark();
  public order: Order = new Order();
  public orderId: number;
  public addFileItem = false;
  public isUploading = false;
  public isNotAdd = false;
  public imageUrl = null;
  public hasBaseDropZoneOver = false;
  public disableBtn = false;

  @ViewChild('sendRequestModal', {static: false}) sendRequestModal = null;
  @ViewChild('serviceRemarkForm', {static: false}) serviceRemarkForm = null;

  constructor(
    public helper: Helper,
    private router: Router,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private auth: AuthenticationService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {

      if (Helper.isDefined(params['id'])) {
        this.orderId = params['id'];
        this.orderService.getOrder(this.orderId).subscribe((resp) => {
          this.order = resp;
        });
      }
    });
  }

  submitItem(next: boolean) {
    if (next) {
      this.disableBtn = true;
      const serviceRemark = JSON.parse(JSON.stringify(this.serviceRemark));
      const files = [];
      serviceRemark.files.forEach((item) => {
        if (item.id) {
          files.push(item.id);
        } else {
          files.push(item);
        }
      });
      serviceRemark.files = files;
      serviceRemark.order = this.orderId;

      this.orderService.manageServiceRemark(serviceRemark, this.orderId).subscribe((resp) => {
        this.disableBtn = false;
        this.sendRequestModal.show();
      });
    } else {
      this.router.navigateByUrl('/dealer-system/order/overview');
    }
  }

  sendRequest() {
    this.serviceRemarkForm.reset();
    this.serviceRemark.files = [];
    this.sendRequestModal.hide();
    window.history.back();
  }

}
